import { AddIcon } from '@approvalmax/ui';
import { Box, Button, Flex, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { InfoCard } from 'shared/components';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';
import { usePermissions } from 'shared/hooks/usePermissions';

import { messages } from './EmptyPaymentDetails.messages';
import { EmptyPaymentDetailsProps } from './EmptyPaymentDetails.types';

export const EmptyPaymentDetails = memo<EmptyPaymentDetailsProps>((props) => {
    const { onAdd } = props;

    const company = useCompanyBasedOnUrl();

    const { isPaymentDetailsAddEnabled } = usePermissions(company);

    return (
        <InfoCard title={messages.title}>
            <Box spacing='40 0'>
                <Flex direction='column' spacing='24' alignItems='center' justifyContent='center'>
                    <Text font='headline' fontSize='small' fontWeight='medium'>
                        {messages.noPaymentDetails}
                    </Text>

                    <Text font='body' fontSize='medium' fontWeight='regular'>
                        {messages.description}
                    </Text>

                    {isPaymentDetailsAddEnabled && (
                        <Button color='blue80' startIcon={<AddIcon />} size='large' onClick={onAdd}>
                            {messages.addDetails}
                        </Button>
                    )}
                </Flex>
            </Box>
        </InfoCard>
    );
});

EmptyPaymentDetails.displayName = 'EmptyPaymentDetails';
